import { render, staticRenderFns } from "./writeFromDectation.vue?vue&type=template&id=40abf6b3&scoped=true&"
import script from "./writeFromDectation.vue?vue&type=script&lang=js&"
export * from "./writeFromDectation.vue?vue&type=script&lang=js&"
import style0 from "./writeFromDectation.vue?vue&type=style&index=0&id=40abf6b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40abf6b3",
  null
  
)

export default component.exports